import styled, { css } from 'styled-components';
import { mediaMixin, token } from '@zillow/constellation';

// Constellation Components
import { Spinner } from '@zillow/constellation';

export const SearchModuleContainer = styled.div`
  width: 100%;

  ${mediaMixin(
    'md',
    css`
      max-width: 568px;
      padding: 24px 0;
    `,
  )};
`;

export const AddressInputContainer = styled.div`
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${mediaMixin(
    'md',
    css`
      flex-direction: row;
    `,
  )};
`;

export const UnitInputContainer = styled.div`
  float: right;
  max-width: 96px;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EmailInputContainer = styled.div`
  padding-bottom: 8px;
`;

export const InputError = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: ${token('colors.orange400')};
  padding: 5px 0;
  float: left;
`;

export const Disclaimer = styled.div<{ fontColor: string }>`
  float: left;
  font-size: 10px;
  color: ${({ fontColor }) => css`
    ${fontColor === 'light' ? token('colors.white') : token('colors.textMedium')};
  `};
  padding-bottom: 12px;
`;

export const ButtonContainer = styled.div`
  float: left;
`;

export const LoadingSpinner = styled(Spinner)`
  position: absolute;
  margin-left: 8px;
`;
